class Util {
  get local() {
    return (
      location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    );
  }
}

export default new Util();
